import React from 'react'
import { Link } from 'gatsby'

const ThreeTableGrid = props => {
  return (
    
    <section className="g-py-100">
    <div className="container">
      <header className="text-center g-width-60x--md mx-auto g-mb-50">
        <div className="u-heading-v2-3--bottom g-brd-primary g-mb-20">
          <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase">Our Vision</h2>
        </div>
        <p className="g-font-size-16">
          Hempgrid's technology platform is under construction through partnerships with 
          some of the brightest minds across the agriculture, supply chain and manufacturing 
          industry. We are currently accepting applications to be a part of our pre-release 
          platform and help to steer the platform's direction. <Link to="/signup">Join today!</Link> 
        </p>
      </header>

      {/*
      <div className="row justify-content-center g-mb-20">
        <div className="col-md-6 col-lg-4 g-mb-50 g-mb-0--lg">

          <div className="u-shadow-v28 g-bg-white text-left text-md-center rounded g-py-40">

            <header className="text-center g-px-30 mb-5">
              <div className="g-mb-25">
                <span className="u-icon-v2 u-icon-size--md g-brd-gray-light-v4 g-color-primary rounded-circle">
                    <i className="icon-finance-211 u-line-icon-pro"></i>
                  </span>
              </div>
              <h2 className="h5 g-color-gray-dark-v2 g-font-weight-600">Marketing &amp; Consulting</h2>
              <p className="g-font-size-13">This is where we sit down, grab a cup of coffee and dial in the details.</p>
            </header>

            <ul className="list-unstyled mb-0">
              <li className="d-flex align-items-center g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">24/7 support</span>
              </li>
              <li className="d-flex align-items-center u-shadow-v19 g-bg-secondary g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">1610+ elements</span>
              </li>
              <li className="d-flex align-items-center g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">600+ pages</span>
              </li>
              <li className="d-flex align-items-center u-shadow-v19 g-bg-secondary g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">Unlimited domain or user</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 g-mb-50 g-mb-0--lg">

          <div className="u-shadow-v29 g-bg-primary text-left text-md-center rounded g-py-40">

            <header className="text-center g-px-35 mb-5">
              <div className="g-mb-25">
                <span className="u-icon-v3 u-icon-size--md g-color-text g-bg-secondary rounded-circle">
                    <i className="icon-finance-257 u-line-icon-pro"></i>
                  </span>
              </div>
              <h2 className="h5 g-color-white g-font-weight-600">SEO &amp; Advertising</h2>
              <p className="g-color-white-opacity-0_9 g-font-size-13">Now that we've aligned the details, it's time to get things organized.</p>
            </header>

            <ul className="list-unstyled g-color-white-opacity-0_8 mb-0">
              <li className="d-flex align-items-center g-px-35 g-py-15">
                <svg width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#fff"></path>
                </svg>
                <span className="ml-3">24/7 support</span>
              </li>
              <li className="d-flex align-items-center u-shadow-v19 g-bg-white-opacity-0_1 g-px-35 g-py-15">
                <svg width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#fff"></path>
                </svg>
                <span className="ml-3">1610+ elements</span>
              </li>
              <li className="d-flex align-items-center g-px-35 g-py-15">
                <svg width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#fff"></path>
                </svg>
                <span className="ml-3">600+ pages</span>
              </li>
              <li className="d-flex align-items-center u-shadow-v19 g-bg-white-opacity-0_1 g-px-35 g-py-15">
                <svg width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#fff"></path>
                </svg>
                <span className="ml-3">Unlimited domain or user</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-6 col-lg-4">

          <div className="u-shadow-v28 g-bg-white text-left text-md-center rounded g-py-40">

            <header className="text-center g-px-35 mb-5">
              <div className="g-mb-25">
                <span className="u-icon-v2 u-icon-size--md g-brd-gray-light-v4 g-color-primary rounded-circle">
                    <i className="icon-communication-164 u-line-icon-pro"></i>
                  </span>
              </div>
              <h2 className="h5 g-color-gray-dark-v2 g-font-weight-600">Design &amp; Development</h2>
              <p className="g-font-size-13">This is where we begin to visualize your sketches and make them into beautiful pixels.</p>
            </header>

            <ul className="list-unstyled mb-0">
              <li className="d-flex align-items-center g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">24/7 support</span>
              </li>
              <li className="d-flex align-items-center u-shadow-v19 g-bg-secondary g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">1610+ elements</span>
              </li>
              <li className="d-flex align-items-center g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">600+ pages</span>
              </li>
              <li className="d-flex align-items-center u-shadow-v19 g-bg-secondary g-px-35 g-py-15">
                <svg className="g-fill-primary" width="13" height="13" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" fill="#72c02c"></path>
                </svg>
                <span className="g-color-text ml-3">Unlimited domain or user</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      */}
    </div>

  </section>

  )
}

export default ThreeTableGrid
